import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { HTMLMessageWithScroll } from '../models';
import { useStores } from '../stores';
import { getCookie, MESSAGE_TYPE_RECEIVED } from '../utilities';
import useConfig from './useConfig';

async function getOneLoginMsg(oneLoginURL, sessionID) {
  try {
    const response = await fetch(`${oneLoginURL}?ClientSessionID=${sessionID}`);
    const msg = await response.text();
    return msg;
  } catch (error) {
    return '';
  }
}

export default function useCookie() {
  const { chatHistoryCSS, endpoints } = useConfig();
  const { chat, chatWindow } = useStores();
  const isSent = useRef(false);
  const { t } = useTranslation();

  if (!isSent.current && chatWindow.isCookie) {
    isSent.current = true;
    const sessionID = getCookie('redirectURL_cookie');
    const chatHist = localStorage.getItem('redirectURL_chatHist');
    document.cookie = 'redirectURL_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    setTimeout(() => {
      const el = document.createElement('style');
      el.innerText = chatHistoryCSS;
      document.head.appendChild(el);

      document.querySelector('#messages-content').innerHTML = chatHist;
      localStorage.removeItem('redirectURL_chatHist');

      getOneLoginMsg(endpoints.oneLoginURL, sessionID).then(OneLoginMsg => {
        const contentMsg = OneLoginMsg.split('"').join('');

        if (contentMsg !== '') {
          chat.addMessage(
            new HTMLMessageWithScroll({
              content: contentMsg,
              type: MESSAGE_TYPE_RECEIVED
            })
          );
        } else {
          chat.addMessage(
            new HTMLMessageWithScroll({
              content: t('welcomeMessage', {
                escapeValue: false
              }),
              type: MESSAGE_TYPE_RECEIVED
            })
          );
        }
      });
    }, 500);
  }
}
